App.ModifierRestaurantPrice = DS.Model.extend
  price         : DS.attr 'number'
  is_hidden     : DS.attr 'boolean'

  # Внешние связи
  modifier      : DS.belongsTo 'modifier',       async: true
  restaurant    : DS.belongsTo 'restaurant', async: true

  nullify_price: (->
    if @get('price') == ''
      Em.run.later =>
        @set('price',null) if @get('price') == ''
      , 1000
  ).observes('price')

  priceIsSet: (->
    @get('price') != null || @get('is_hidden')
  ).property('price', 'is_hidden')
